//apiStatus
export const apiStatus = {
  NONE: 'NONE',
  INITIATED: 'initiated',
  SUCCESS: 'success',
  ERROR: 'error',
};

export const navBarConfigActionType = {
  SET_CONFIG: 'SET_CONFIG',
  RESET: 'RESET',
};

export const commonActionType = {
  INIT_QUERY: 'INIT_QUERY',
  STORE_DATA: 'STORE_DATA',
  UPDATE_TEMPLATE: 'UPDATE_TEMPLATE',
  UPDATE_PAGE_KEY: 'UPDATE_PAGE_KEY',
  CLEAR_STORE: 'CLEAR_STORE',
  CHANGE_ROUTE: 'CHANGE_ROUTE',
};

export const paymentInitActionType = {
  TRANSACTION_INFO_REQUEST: 'TRANSACTION_INFO_REQUEST',
  TRANSACTION_INFO_SUCCESS: 'TRANSACTION_INFO_SUCCESS',
  UPDATE_TRANSACTION_LENDER_TYPE: 'UPDATE_TRANSACTION_LENDER_TYPE',
  TRANSACTION_INFO_ERROR: 'TRANSACTION_INFO_ERROR',
  TRANSACTION_INFO_PRE_SELECTED_SUCCESS:
    'TRANSACTION_INFO_PRE_SELECTED_SUCCESS',
  TRANSACTION_TIMEOUT_STORE: 'TRANSACTION_TIMEOUT_STORE',
  TRANSACTION_TIMEOUT_ERROR_MESSAGE: 'TRANSACTION_TIMEOUT_ERROR_MESSAGE',
  TRANSACTION_INFO_CLEAR_SELECTED_LENDER_EMI:
    'TRANSACTION_INFO_CLEAR_SELECTED_LENDER_EMI',
  UPDATE_REDIRECT_TO_ENTER_MOBILE: 'UPDATE_REDIRECT_TO_ENTER_MOBILE',

  //experiment-data
  TRANSACTION_VARIANT_BENEFIT_POPUP_RESPONSE:
    'TRANSACTION_VARIANT_BENEFIT_POPUP_RESPONSE',
  UPDATE_TXN_TERMINATION_DATA: 'UPDATE_TXN_TERMINATION_DATA',
};

export const paymentEnterMobileActionType = {
  UPDATE_TRANSACTION_MOBILE_NUMBER: 'UPDATE_TRANSACTION_MOBILE_NUMBER',
  UPDATE_TRANSACTION_MOBILE_NUMBER_ERROR:
    'UPDATE_TRANSACTION_MOBILE_NUMBER_ERROR',
};

export const lenderListActionType = {
  USER_TRANSACTION_INFO_REQUEST: 'USER_TRANSACTION_INFO_REQUEST',
  USER_TRANSACTION_INFO_SUCCESS: 'USER_TRANSACTION_INFO_SUCCESS',
  USER_TRANSACTION_INFO_ERROR: 'USER_TRANSACTION_INFO_ERROR',
  SELECT_LENDER: 'SELECT_LENDER',
};

export const paymentEmiActionType = {
  SELECT_EMI: 'SELECT_EMI',
  CLOSED_BENEFIT_MODEL: 'CLOSED_BENEFIT_MODEL',
};

export const paymentConfirmActionType = {
  //Kfs Data
  INITIATE_GET_KFS_DATA_REQUEST: 'INITIATE_GET_KFS_DATA_REQUEST',
  INITIATE_GET_KFS_DATA_SUCCESS: 'INITIATE_GET_KFS_DATA_SUCCESS',
  INITIATE_GET_KFS_DATA_ERROR: 'INITIATE_GET_KFS_DATA_ERROR',
  //Second Factor
  FORGOT_PIN_TRANSACTION_REQUEST: 'FORGOT_PIN_TRANSACTION_REQUEST',
  FORGOT_PIN_TRANSACTION_SUCCESS: 'FORGOT_PIN_TRANSACTION_SUCCESS',
  FORGOT_PIN_TRANSACTION_ERROR: 'FORGOT_PIN_TRANSACTION_ERROR',
  //transaction
  INITIATE_TXN_REQUEST: 'INITIATE_TXN_REQUEST',
  INITIATE_TXN_SUCCESS: 'INITIATE_TXN_SUCCESS',
  INITIATE_TXN_ERROR: 'INITIATE_TXN_ERROR',
  CONFIRM_TRANSACTION_REQUEST: 'CONFIRM_TRANSACTION_REQUEST',
  CONFIRM_TRANSACTION_SUCCESS: 'CONFIRM_TRANSACTION_SUCCESS',
  CONFIRM_TRANSACTION_ERROR: 'CONFIRM_TRANSACTION_ERROR',
  RESEND_TRANSACTION_OTP_REQUEST: 'RESEND_TRANSACTION_OTP_REQUEST',
  RESEND_TRANSACTION_OTP_SUCCESS: 'RESEND_TRANSACTION_OTP_SUCCESS',
  RESEND_TRANSACTION_OTP_ERROR: 'RESEND_TRANSACTION_OTP_ERROR',
};

export const paymentCancelActionType = {
  SHOULD_INITIATE_CANCEL_TRANSACTION: 'INITIATE_CANCEL_TRANSACTION',
  REJECT_INITIATE_CANCEL_TRANSACTION: 'REJECT_INITIATE_CANCEL_TRANSACTION',
  CANCEL_TRANSACTION_REQUEST: 'CANCEL_TRANSACTION_REQUEST',
  CANCEL_TRANSACTION_SUCCESS: 'CANCEL_TRANSACTION_SUCCESS',
  CANCEL_TRANSACTION_ERROR: 'CANCEL_TRANSACTION_ERROR',
};

export const paymentHelpText = {
  DISPLAY_HELP_TEXT: 'DISPLAY_HELP_TEXT',
};

export const offlineActionType = {
  POS_SEND_SMS_TO_INITIATE_TXN_AUTH_REQUEST_SUCCESS:
    'POS_SEND_SMS_TO_INITIATE_TXN_AUTH_REQUEST_SUCCESS',
  POS_TXN_STATUS_REQUEST: 'POS_TXN_STATUS_REQUEST',
  POS_TXN_STATUS_SUCCESS: 'POS_TXN_STATUS_SUCCESS',
  POS_TXN_STATUS_ERROR: 'POS_TXN_STATUS_ERROR',
  POS_TXN_DETAILS_REQUEST: 'POS_TXN_DETAILS_REQUEST',
  POS_TXN_DETAILS_SUCCESS: 'POS_TXN_DETAILS_SUCCESS',
  POS_TXN_DETAILS_ERROR: 'POS_TXN_DETAILS_ERROR',
};

export const PAYMENT_ERROR_DATA = 'PAYMENT_ERROR_DATA';

export const setupPinInitActionType = {
  INITIATE_SETUP_PIN: 'INITIATE_SETUP_PIN',
};

export const setupPinSecondFactorActionType = {
  INITIATE_CREDIT_LINE: 'INITIATE_CREDIT_LINE',
};

export const changePinActionType = {
  POST_CHANGE_PIN_API_INITIATE: 'POST_CHANGE_PIN_API_INITIATE',
  POST_CHANGE_PIN_API_SUCCESS: 'POST_CHANGE_PIN_API_SUCCESS',
  POST_CHANGE_PIN_API_ERROR: 'POST_CHANGE_PIN_API_ERROR',
  CHANGE_PIN_UPDATE_ERROR_MESSAGE: 'CHANGE_PIN_UPDATE_ERROR_MESSAGE',
};

export const loginActionType = {
  UPDATE_MOBILE_NUMBER: 'UPDATE_MOBILE_NUMBER',
  INITIATE_LOGIN_REQUEST: 'INITIATE_LOGIN_REQUEST',
  INITIATE_LOGIN_SUCCESS: 'INITIATE_LOGIN_SUCCESS',
  INITIATE_LOGIN_ERROR: 'INITIATE_LOGIN_ERROR',
  RESET_ERROR_MESSAGE: 'RESET_ERROR_MESSAGE',
  VERIFY_AUTH_REQUEST: 'VERIFY_AUTH_REQUEST',
  VERIFY_AUTH_SUCCESS: 'VERIFY_AUTH_SUCCESS',
  VERIFY_AUTH_ERROR: 'VERIFY_AUTH_ERROR',
  RESET_LOGIN_INIT_API_STATE: 'RESET_LOGIN_INIT_API_STATE',
};

export const identifyUserActionType = {
  IDENTIFY_USER_SUCCESS: 'IDENTIFY_USER_SUCCESS',
  IDENTIFY_USER_FAILURE: 'IDENTIFY_USER_FAILURE',
  IDENTIFY_USER_AUTH_SET: 'IDENTIFY_USER_AUTH_SET',
  IDENTIFY_USER_AUTH_RESET: 'IDENTIFY_USER_AUTH_RESET',
};

export const registrationInitActionType = {
  INITIATE_CAMPAIGN_REQUEST: 'INITIATE_CAMPAIGN_REQUEST',
  INITIATE_CAMPAIGN_SUCCESS: 'INITIATE_CAMPAIGN_SUCCESS',
  INITIATE_CAMPAIGN_ERROR: 'INITIATE_CAMPAIGN_ERROR',
  INITIATE_ACTIVATION_DATA_REQUEST: 'INITIATE_ACTIVATION_DATA_REQUEST',
  INITIATE_ACTIVATION_DATA_SUCCESS: 'INITIATE_ACTIVATION_DATA_SUCCESS',
  INITIATE_ACTIVATION_DATA_ERROR: 'INITIATE_ACTIVATION_DATA_ERROR',
  UPDATE_ERROR_MESSAGE: 'UPDATE_ERROR_MESSAGE',
  POST_REGISTRATION_INITIATE_REQUEST: 'POST_REGISTRATION_INITIATE_REQUEST',
  POST_REGISTRATION_INITIATE_SUCCESS: 'POST_REGISTRATION_INITIATE_SUCCESS',
  POST_REGISTRATION_INITIATE_ERROR: 'POST_REGISTRATION_INITIATE_ERROR',
};

export const registrationSecondFactorType = {
  POST_INITIATE_CREDIT_LINE_REQUEST: 'POST_INITIATE_CREDIT_LINE_REQUEST',
  POST_INITIATE_CREDIT_LINE_SUCCESS: 'POST_INITIATE_CREDIT_LINE_SUCCESS',
  POST_INITIATE_CREDIT_LINE_ERROR: 'POST_INITIATE_CREDIT_LINE_ERROR',
  POST_VERIFY_CREDIT_LINE_REQUEST: 'POST_VERIFY_CREDIT_LINE_REQUEST',
  POST_VERIFY_CREDIT_LINE_SUCCESS: 'POST_VERIFY_CREDIT_LINE_SUCCESS',
  POST_VERIFY_CREDIT_LINE_ERROR: 'POST_VERIFY_CREDIT_LINE_ERROR',
  POST_ACTIVATION_PIN_REQUEST: 'POST_ACTIVATION_PIN_REQUEST',
  POST_ACTIVATION_PIN_SUCCESS: 'POST_ACTIVATION_PIN_SUCCESS',
  POST_ACTIVATION_PIN_ERROR: 'POST_ACTIVATION_PIN_ERROR',
};

export const brandActionType = {
  INIT_BRAND_SCREEN_REQUEST: 'INIT_BRAND_SCREEN_REQUEST',
  INIT_BRAND_SCREEN_SUCCESS: 'INIT_BRAND_SCREEN_SUCCESS',
  INIT_BRAND_SCREEN_ERROR: 'INIT_BRAND_SCREEN_ERROR',
};

export const categoryActionType = {
  INIT_CATEGORY_SCREEN_REQUEST: 'INIT_CATEGORY_SCREEN_REQUEST',
  INIT_CATEGORY_SCREEN_SUCCESS: 'INIT_CATEGORY_SCREEN_SUCCESS',
  INIT_CATEGORY_SCREEN_ERROR: 'INIT_CATEGORY_SCREEN_ERROR',
};

export const merchantActionType = {
  INIT_MERCHANT_SCREEN_REQUEST: 'INIT_MERCHANT_SCREEN_REQUEST',
  INIT_MERCHANT_SCREEN_SUCCESS: 'INIT_MERCHANT_SCREEN_SUCCESS',
  INIT_MERCHANT_SCREEN_ERROR: 'INIT_MERCHANT_SCREEN_ERROR',
  LOAD_MORE_MERCHANT: 'LOAD_MORE_MERCHANT',
  APPLY_MERCHANT_FILTER: 'APPLY_MERCHANT_FILTER',
  CLEAR_SEARCH_TEXT: 'CLEAR_SEARCH_TEXT',
  CLOSE_FILTER: 'CLOSE_FILTER',
  CLEAR: 'CLEAR',
};

export const homeActionType = {
  INIT_CATEGORY_SCREEN: 'INIT_CATEGORY_SCREEN',
  INIT_BRAND_SCREEN: 'INIT_BRAND_SCREEN',
  INIT_MERCHANT_SCREEN: 'INIT_MERCHANT_SCREEN',
  TOGGLE_FILTER: 'TOGGLE_FILTER',
  INIT_FAQ_SCREEN: 'INIT_FAQ_SCREEN',
  INIT_CHANGE_PIN_SCREEN: 'INIT_CHANGE_PIN_SCREEN',
  INIT_HTB_SCREEN: 'INIT_HTB_SCREEN',
  INIT_VOUCHER_SCREEN: 'INIT_VOUCHER_SCREEN',
  INIT_LOGIN_SCREEN: 'INIT_LOGIN_SCREEN',
  INIT_ACCOUNT_SCREEN: 'INIT_ACCOUNT_SCREEN',
  INIT_TRANSACTION_HISTORY: 'INIT_TRANSACTION_HISTORY',
  SUD_API_REQUEST: 'SUD_API_REQUEST',
  SUD_API_SUCCESS: 'SUD_API_SUCCESS',
  SUD_API_ERROR: 'SUD_API_ERROR',
  SUD_STATUS_RESET: 'SUD_STATUS_RESET',
  GET_ELIGIBLE_LENDERS_API_REQUEST: 'GET_ELIGIBLE_LENDERS_API_REQUEST',
  GET_ELIGIBLE_LENDERS_API_SUCCESS: 'GET_ELIGIBLE_LENDERS_API_SUCCESS',
  GET_ELIGIBLE_LENDERS_API_ERROR: 'GET_ELIGIBLE_LENDERS_API_ERROR',
  GET_ELIGIBLE_LENDERS_STATUS_RESET: 'GET_ELIGIBLE_LENDERS_STATUS_RESET',
  TOGGLE_SEARCH_AND_FILTER_CATEGORY: 'TOGGLE_SEARCH_AND_FILTER_CATEGORY',
};

export const headerActionType = {
  FIXED_HEADER: 'FIXED_HEADER',
  REMOVE_FIXED_HEADER: 'REMOVE_FIXED_HEADER',
};

export const ntbActionType = {
  SEND_OTP_REQUEST: 'SEND_OTP_REQUEST',
  SEND_OTP_SUCCESS: 'SEND_OTP_SUCCESS',
  SEND_OTP_FAILURE: 'SEND_OTP_FAILURE',
  VERIFY_OTP_SUCCESS: 'VERIFY_OTP_SUCCESS',
  VERIFY_OTP_FAILURE: 'VERIFY_OTP_FAILURE',
  INIT_OTP_SCREEN: 'INIT_OTP_SCREEN',
  INIT_SUD: 'INIT_SUD',
  SUD_API_SUCCESS: 'SUD_API_SUCCESS',
  SUD_API_ERROR: 'SUD_API_ERROR',
  LENDER_LIST: 'LENDER_LIST',
  LENDER_LIST_REQUEST: 'LENDER_LIST_REQUEST',
  LENDER_LIST_SUCCESS: 'LENDER_LIST_SUCCESS',
  LENDER_LIST_FAILURE: 'LENDER_LIST_FAILURE',
  INIT_LENDER_LIST_SCREEN: 'INIT_LENDER_LIST_SCREEN',
  CLOSE_OTP_OVERLAY_SCREEN: 'CLOSE_OTP_OVERLAY_SCREEN',
  CLOSE_OVERLAY_SCREEN: 'CLOSE_OVERLAY_SCREEN',
  OPEN_OVERLAY_SCREEN: 'OPEN_OVERLAY_SCREEN',
  CLOSE_ELIGIBILITY_MODAL: 'CLOSE_ELIGIBILITY_MODAL',
  OPEN_ELIGIBILITY_MODAL: 'OPEN_ELIGIBILITY_MODAL',
  CLOSE_ELIGIBILITY_CHECK_MODAL: 'CLOSE_ELIGIBILITY_CHECK_MODAL',
  OPEN_ELIGIBILITY_CHECK_MODAL: 'OPEN_ELIGIBILITY_CHECK_MODAL',
  OPEN_SERVICE_UNAVAILABLE_MODAL: 'OPEN_SERVICE_UNAVAILABLE_MODAL',
  USER_STATUS: 'USER_STATUS',
  NTB_RESET: 'NTB_RESET',
};

export const WIDGET_STORE_HEADER = 'WIDGET_STORE_HEADER';
export const WIDGET_STORE_MERCHANT_DATA = 'WIDGET_STORE_MERCHANT_DATA';
export const WIDGET_STORE_META_DATA = 'WIDGET_STORE_META_DATA';

export const widgetCheckEligibleActionType = {
  INIT_CHECK_ELIGIBLE_WIDGET_SCREEN: 'INIT_CHECK_ELIGIBLE_WIDGET_SCREEN',
  WIDGET_SEND_OTP_REQUEST: 'WIDGET_SEND_OTP_REQUEST',
  WIDGET_SEND_OTP_SUCCESS: 'WIDGET_SEND_OTP_SUCCESS',
  WIDGET_SEND_OTP_FAILURE: 'WIDGET_SEND_OTP_FAILURE',
  WIDGET_VERIFY_OTP_REQUEST: 'WIDGET_VERIFY_OTP_REQUEST',
  WIDGET_VERIFY_OTP_SUCCESS: 'WIDGET_VERIFY_OTP_SUCCESS',
  WIDGET_VERIFY_OTP_FAILURE: 'WIDGET_VERIFY_OTP_FAILURE',
  WIDGET_NTB_SMS_INITIATE: 'WIDGET_NTB_SMS_REQUEST_INITIATE',
  WIDGET_NTB_SMS_SUCCESS: 'WIDGET_NTB_SMS_SUCCESS',
  WIDGET_NTB_SMS_ERROR: 'WIDGET_NTB_SMS_ERROR',
};

export const aboutUsActionType = {
  INIT_ABOUT_US: 'INIT_ABOUT_US',
};

export const dataManagementPolicyActionType = {
  DATA_MANAGEMENT_POLICY: 'DATA_MANAGEMENT_POLICY',
};

export const widgetEMIInfoActionType = {
  WIDGET_EMI_INFO_REQUEST: 'WIDGET_EMI_INFO_REQUEST',
  WIDGET_EMI_INFO_SUCCESS: 'WIDGET_EMI_INFO_SUCCESS',
  WIDGET_EMI_INFO_FAILURE: 'WIDGET_EMI_INFO_FAILURE',
  WIDGET_HOW_TO_BUY_REQUEST: 'WIDGET_HOW_TO_BUY_REQUEST',
  WIDGET_HOW_TO_BUY_SUCCESS: 'WIDGET_HOW_TO_BUY_SUCCESS',
  WIDGET_HOW_TO_BUY_FAILURE: 'WIDGET_HOW_TO_BUY_FAILURE',
};

export const ntbFlowActionType = {
  NTB_SET_APPLICATION_ID: 'NTB_SET_APPLICATION_ID',
  NTB_SET_LENDER: 'NTB_SET_LENDER',
  NTB_SET_STEP: 'NTB_SET_STEP',
  NTB_SET_CREDIT_APPLICATION_STATUS_RESPONSE:
    'NTB_SET_CREDIT_APPLICATION_STATUS_RESPONSE',
  NTB_SET_FILTER_SELECTED_REJECTED_LENDER:
    'NTB_SET_FILTER_SELECTED_REJECTED_LENDER',
  NTB_SET_LENDER_WINDOW_URL: 'NTB_SET_LENDER_WINDOW_URL',
  NTB_SET_MERCHANT_ID: 'NTB_SET_MERCHANT_ID',
  NTB_SET_PRE_ELIGIBLE_LENDERS: 'NTB_SET_PRE_ELIGIBLE_LENDERS',
  NTB_SET_RESET_STATE: 'NTB_SET_RESET_STATE',
};

export const ntbFaqActionType = {
  INIT_NTB_FAQ: 'INIT_NTB_FAQ',
};

export const privacyPolicyActionType = {
  INIT_PRIVACY_POLICY: 'INIT_PRIVACY_POLICY',
};

//LAYERS (model, snackbar and others)
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';

export const modalActionType = {
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
};

//error block transaction modal
export const errorBlockTransactionDisplay = {
  DISPLAY_HELP_TEXT: 'DISPLAY_HELP_TEXT',
};
//Tracking
export const TRACKING_TRANSACTION = 'TRACKING_TRANSACTION';

//program-page
export const programPageActionType = {
  GET_CREDIT_SCHEME_REQUEST: 'GET_CREDIT_SCHEME_REQUEST',
  GET_CREDIT_SCHEME_SUCCESS: 'GET_CREDIT_SCHEME_SUCCESS',
  GET_CREDIT_SCHEME_FAILURE: 'GET_CREDIT_SCHEME_FAILURE',
};

export const odrActionType = {
  CREATE_TICKET_REQUEST: 'CREATE_TICKET_REQUEST',
  CREATE_TICKET_SUCCESS: 'CREATE_TICKET_SUCCESS',
  CREATE_TICKET_FAILURE: 'CREATE_TICKET_FAILURE',
  VIEW_TICKET_REQUEST: 'VIEW_TICKET_REQUEST',
  VIEW_TICKET_SUCCESS: 'VIEW_TICKET_SUCCESS',
  VIEW_TICKET_FAILURE: 'VIEW_TICKET_FAILURE',
  UPDATE_TICKET_REQUEST: 'UPDATE_TICKET_REQUEST',
  UPDATE_TICKET_SUCCESS: 'UPDATE_TICKET_SUCCESS',
  UPDATE_TICKET_FAILURE: 'UPDATE_TICKET_FAILURE',
};

//Transaction History Data

export const transactionHistoryType = {
  TRANSACTION_HISTORY_DATA: 'TRANSACTION_HISTORY_DATA',
  FILTER_COLUMNS_DATA: 'FILTER_COLUMNS_DATA',
};

export const ntbPaymentActionType = {
  NTB_PAYMENT_SET_WHATSAPP_CONSENT: 'NTB_PAYMENT_SET_WHATSAPP_CONSENT',
  NTB_PAYMENT_SET_PRE_ELIGIBLE_LENDERS: 'NTB_PAYMENT_SET_PRE_ELIGIBLE_LENDERS',
  NTB_PAYMENT_SET_PRE_ELIGIBLE_FAILURE_MESSAGE:
    'NTB_PAYMENT_SET_PRE_ELIGIBLE_FAILURE_MESSAGE',
  NTB_PAYMENT_SET_USER_PAN: 'NTB_PAYMENT_SET_USER_PAN',
};

export const transactionHistoryTypeData = 'transactionHistoryTypeData';
export const getTransactionData = 'getTransactionData';



// WEBPACK FOOTER //
// ./components/transaction/src/actionTypes/index.js